(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storaze-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-arrivals-rotator')) {
    customElements.define('new-arrivals-rotator', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-arrivals-slide]')];
        this.dots = [...this.querySelectorAll('[data-arrivals-dot]')];
        this.status = this.querySelector('[data-arrivals-status]');
        this.pauseButton = this.querySelector('[data-arrivals-pause]');
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-arrivals-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-arrivals-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.arrivalsDot), true)));
        this.pauseButton?.addEventListener('click', () => this.togglePause());
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      show(next, userInitiated) {
        if (!this.slides.length) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
        if (userInitiated) this.restart();
      }
      start() {
        if (this.paused || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.index + 1, false), Number(this.dataset.delay) || 6000);
      }
      stop() { window.clearInterval(this.timer); this.timer = null; }
      restart() { this.stop(); this.start(); }
      togglePause() {
        this.paused = !this.paused;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
        if (this.paused) this.stop(); else this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storaze-policy-links"] && !Shopify.designMode) return;
  try {
    
  (()=>{const art=document.querySelector('[data-policy-art]');const container=document.querySelector('.shopify-policy__container');if(art&&container&&!container.contains(art)){container.prepend(art)}})();

  } catch(e) { console.error(e); }
})();
})();
